// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PFDA","content":"styles_content__10awA"};